define('views/parts/form/color-picker',[
    // Libs
    'underscore', 'backbone', 'mustache', 'colorpicker', 'color', 'utils',
    // templates
    'text!templates/parts/form/color-picker.html',
    'text!templates/parts/form/color-picker-template.html'
], function(
    // Libs
    _, Backbone, Mustache, Colorpicker, Color, U,
    // templates
    TColorPicker,
    TColorPickerTemplate
) {

    var VColorPicker = Backbone.Epoxy.View.extend({
        template: TColorPicker,
        events: {
            "changeColor input": "onColorChange",
            "hidePicker input": "onPickerHide",
            "click .colorpicker-btn": "onButtonClick",
        },
        regions: {
            root: ".input-placeholder",
            input: ".colorpicker-input",
            button: ".colorpicker-btn",
        },
        bindingFilters: {
            fontColor: function(colorHex) {
                //if invalid color, default blue TC
                if (!/^#[0-9A-F]{6}$/i.test(colorHex)) {
                  colorHex = '#00adef';
                }
                var color = new Color(colorHex);
                return color.lightness() > 0.5 ? "#000" : "#fff";
            }
        },

        initialize: function(opt) {
            var defaultAttribute = 'color',
                // default options
                options = this.options = _.extend({
                    name: opt.attribute || defaultAttribute,
                    id: this.cid,
                    labelposition: "top",
                    label: "Pick a color",
                    attribute: defaultAttribute,
                    saturation: true,
                    hue: true,
                    alpha: false,
                    color: false,
                    selectors: false
                }, opt);

            // default colorpicker options
            var colorpickerOptions = options.colorpicker = _.extend({
                format: 'hex',
                template: TColorPickerTemplate
            }, options.colorpicker);

            // applying the template
            colorpickerOptions.template = Mustache.render(colorpickerOptions.template, options);

            if (!this.model) {
                this.model = new Backbone.Model();
                this.model.set(options.attribute, "#ffffff");
            }
        },
        render: function() {

            var html = Mustache.render(this.template, Mustache.getContext(this.options));
            this.$el.empty().append(html);
            this.applyBindings();

            this.generateZones()
                .initColorPicker();

            return this;
        },

        initColorPicker: function() {
            var zone = this.zone;
            this.colorpicker = zone.$input
                .colorpicker(_.extend({}, this.options.colorpicker, {
                    container: zone.$root
                })).data('colorpicker');

            return this;
        },

        toggleDisabled: function(val) {
            var colorpicker = this.colorpicker;
            if (colorpicker) {
                colorpicker[val ? 'enable' : 'disable']();
                // zone.$input.colorpicker(val ? 'enable' : 'disable');
            }
        },

        ////////////
        // events //
        ////////////
        onColorChange: function(e) {
            var color = e.color,
                length = e.currentTarget.value.length;
            if (color.origFormat && length >= 7) {
                this.model.set(this.options.attribute, e.color.toHex());
            }
        },

        onButtonClick: function(e) {
            this.zone.$input.focus();
        },

        onPickerHide: function(e) {
            var value = this.model.get(this.options.attribute);
            this.zone.$input.val(value);
            this.trigger('complete', value, this.model, this);
        }

    });

    return VColorPicker;

});

